import { render, staticRenderFns } from "./MachineTypes.vue?vue&type=template&id=22956848&scoped=true&"
import script from "./MachineTypes.vue?vue&type=script&lang=js&"
export * from "./MachineTypes.vue?vue&type=script&lang=js&"
import style0 from "./MachineTypes.vue?vue&type=style&index=0&id=22956848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22956848",
  null
  
)

component.options.__file = "MachineTypes.vue"
export default component.exports